import React from 'react';

interface CrossIconProps {
  className?: string;
}

function CrossIcon({ className }: CrossIconProps) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <rect width="20.364" height="2.263" fill="currentColor" rx="1.131" transform="rotate(45.001 .8 1.932)"></rect>
      <rect width="20.364" height="2.263" fill="currentColor" rx="1.131" transform="rotate(-45.001 17.382 7.2)"></rect>
    </svg>
  );
}

export default CrossIcon;
